// native
import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-home-code-step',
  templateUrl: './code-step.component.html',
  standalone: false
})
export class CodeStepComponent {
  // The device's pairing code, available only after the setup is created.
  // Unused when needsLinking is false (already-linked existing device).
  @Input() pairingCode: string | null = null;

  // False when an existing already-linked device was selected: re-pairing is
  // neither needed nor possible, so the step shows a success message instead.
  @Input() needsLinking = true;

  @Output() done: EventEmitter<void> = new EventEmitter<void>();
}
